export const MAXIMUM_ORDER_QUANTITY = 10000000
export const MAXIMUM_QUANTITY = 1000000000000
export const MAXIMUM_PRICE = 1000000000000
export const MAXIMUM_BILL_ROUNDING = 100
export const DEFAULT_CURRENCY_SYMBOL = 'Rp.'
export const DEFAULT_QUANTITY_SYMBOL = 'Qty'
export const LITER_TO_KILOGRAM = 0.906198
export const PPN_VALUE = 11
export const MAX_EXPORT_ROWS = 10000
